import {
  LuTarget,
  LuBookOpen,
  LuAward,
  LuTrophy,
  LuCircleCheckBig,
  LuArrowRight,
} from "react-icons/lu";
import { Link } from "react-router-dom";

//Content
const sections = [
  {
    title: "Placement Preparation",
    subtitle: "Get ready for top tech companies",
    description:
      "Comprehensive placement preparation with company-specific questions, mock interviews, and expert guidance. Practice with real interview questions from FAANG and unicorn startups.",
    icon: <LuTarget className="text-white" size={24} />,
    features: [
      "1000+ Company Questions",
      "Mock Interview Sessions",
      "Industry Expert Mentorship",
      "Placement Success Analytics",
    ],
    stats: [
      { value: "94%", label: "Success Rate" },
      { value: "500+", label: "Companies" },
      { value: "50K+", label: "Students Placed" },
    ],
    buttonText: "Explore Placement Preparation",
    linkto:"/placement",
    image: "/api/placeholder/600/400",
  },
  {
    title: "Practice Problems",
    subtitle: "Master coding with 10,000+ problems",
    description:
      "Extensive collection of coding problems from beginner to expert level. Practice data structures, algorithms, system design, and domain-specific challenges with instant feedback.",
    icon: <LuBookOpen className="text-white" size={24} />,
    features: [
      "10,000+ Coding Problems",
      "AI-Powered Hints & Solutions",
      "Progress Tracking",
      "Difficulty-based Learning Path",
    ],
    stats: [
      { value: "10K+", label: "Problems" },
      { value: "25+", label: "Topics" },
      { value: "1M+", label: "Solutions" },
    ],
    buttonText: "Explore Practice Problems",
    linkto:"/quizzes",
    image: "/api/placeholder/600/400",
  },
  {
    title: "Skill Certificates",
    subtitle: "Validate your expertise with industry-recognized certificates",
    description:
      "Earn verified certificates in various technologies and programming languages. Showcase your skills to employers with blockchain-verified credentials that matter in the industry.",
    icon: <LuAward className="text-white" size={24} />,
    features: [
      "Blockchain Verified Certificates",
      "Industry Recognition",
      "LinkedIn Integration",
      "Skill Assessment Tests",
    ],
    stats: [
      { value: "100+", label: "Technologies" },
      { value: "500K+", label: "Certificates Issued" },
      { value: "95%", label: "Employer Recognition" },
    ],
    buttonText: "Explore Skill Certificates",
    linkto:"/certificate",
    image: "/api/placeholder/600/400",
  },
  // {
  //   title: "Coding Tournaments",
  //   subtitle: "Compete with the best developers worldwide",
  //   description:
  //     "Join exciting coding tournaments and hackathons. Compete with developers globally, win prizes, and get noticed by top tech companies looking for talent.",
  //   icon: <LuTrophy className="text-white" size={24} />,
  //   features: [
  //     "Weekly Tournaments",
  //     "Cash Prizes & Internships",
  //     "Global Leaderboards",
  //     "Company Sponsorships",
  //   ],
  //   stats: [
  //     { value: "$100K+", label: "Prize Pool" },
  //     { value: "1000+", label: "Participants" },
  //     { value: "50+", label: "Sponsor Companies" },
  //   ],
  //   buttonText: "Explore Coding Tournaments",
  //   linkto:"/tournaments",
  //   image: "/api/placeholder/600/400",
  // },
];

//reusable-component
const QuizBoardTile = ({ item, index }) => {
  const isEven = index % 2 === 0;

  return (
    <div className="row align-items-center mb-5 pb-5  border-bottom border-primary">
      {/* Left Section (Text) */}
      <div className={`col-lg-6 mb-4 mb-lg-0 ${isEven ? "" : "order-lg-2"}`}>
        <div className="d-flex align-items-center mb-3">
          <div
            className="d-flex align-items-center justify-content-center bg-gradient-primary rounded me-3" //bg-gradient-primary
            style={{ width: "48px", height: "48px" }}
          >
            {item.icon}
          </div>
          <div>
            <h2 className="h3 fw-bold text-light mb-1">{item.title}</h2>
            <p className="text-primary mb-0">{item.subtitle}</p>
          </div>
        </div>

        <p className="text-muted-custom mb-4 lead">{item.description}</p>

        {/* Features */}
        <div className="row mb-4">
          {item.features.map((feature, idx) => (
            <div className="col-md-6 mb-2" key={idx}>
              <div className="d-flex align-items-center">
                <LuCircleCheckBig className="text-accent me-2" size={16} />
                <small className="text-light">{feature}</small>
              </div>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="row mb-4">
          {item.stats.map((stat, idx) => (
            <div className="col-4" key={idx}>
              <div className="text-center">
                <h4 className="fw-bold text-primary mb-1">{stat.value}</h4>
                <small className="text-muted">{stat.label}</small>
              </div>
            </div>
          ))}
        </div>
 
        {/* Button */}
        <Link to={item.linkto} className="text-decoration-none">
        <button className="btn btn-gradient-primary d-flex text-white align-items-center">
          {item.buttonText}
          <LuArrowRight className="ms-2" size={16} />
        </button>
        </Link>
      </div>

      {/* Right Section (Image) */}
      <div className="col-lg-6">
        <div className="card bg-dark-secondary border-primary shadow-glow hover-card">
          <img
            src={item.image}
            alt={item.title}
            className="card-img rounded"
            style={{ height: "350px", objectFit: "cover" }}
          />
          <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient-primary opacity-10 rounded"></div>
        </div>
      </div>
    </div>
  );
};

const QuizBoardTiles = () => {
  return (
    <>
      <section className="row mx-0 py-5">
        <div className="col-10 mx-auto">
          {sections.map((item, index) => (
            <QuizBoardTile key={index} item={item} index={index} />
          ))}
        </div>
      </section>
    </>
  );
};

export default QuizBoardTiles;